import { BaseFilterProps } from 'framework/list';
import EmployeeDropdownFilter from './EmployeeDropdownFilter';

const PeopleManagerFilter = (props: BaseFilterProps) => {
  const filter = {
    'specification:peopleManagerSpecification': {
      eq: true,
    },
  };

  return <EmployeeDropdownFilter filter={filter} {...props} />;
};

export default PeopleManagerFilter;
